// deprecated Jul 21,2021
export function nestedPropertyOrNull_0 (obj, accessor) {
    var arrAccess = accessor.split('.');
    var objDescend = obj[arrAccess[0]];
    while (arrAccess.length > 1 && objDescend !== null) {
        arrAccess.shift();
        if (typeof objDescend === 'object' && arrAccess[0] in objDescend)
          objDescend = objDescend[arrAccess[0]];
        else {
          objDescend = null;
          break;
        }
    } 
    return objDescend;
}

export function nestedPropertyOrNull(obj, accessor) {
    return accessor.split('.').reduce((item, path) => item && item[path] ? item[path] : null, obj)
}
export function nestedProp(obj, accessor) {
    return accessor.split('.').reduce((item, path) => item ? item[path] : undefined, obj)
}

export function setProperty2 (obj, accessor, newValue) {
    accessor.split('.')
     .reduce((o,p,i) => o[p] = accessor.split('.').length === ++i ? newValue : o[p] || {}, obj)
}

// untested support for obj.prop[0].prop2
/*export function nestedProperty3(object, path) {
    path.split(/[\.\[\]\'\"]/)
    .filter(p => p)
    .reduce((o, p) => o ? o[p] : null, object)    
}*/

export function nestedProperty(obj, accessor) {
    var arrAccess = accessor.split('.');
    var objDescend = obj[arrAccess[0]];
    while (arrAccess.length > 1) {
        arrAccess.shift();
        if (typeof objDescend === 'object' && arrAccess[0] in objDescend)
          objDescend = objDescend[arrAccess[0]];
    } 
    return objDescend;
}

export function setNestedProperty (obj, accessor, newValue) {
    var arrAccess = accessor.split('.');
    var objDescend = obj;
    while (arrAccess.length > 1) {
        if (!objDescend[arrAccess[0]])
            objDescend[arrAccess[0]] = { };
        objDescend = objDescend[arrAccess[0]];
        arrAccess.shift();
    } 
    setProperty(objDescend, arrAccess[0], newValue);
}

export function setProperty(obj, propName, value) {
    if (!obj) obj = {};
    obj[propName] = value;
}

export function isEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}
